var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{on:{"click":_vm.download}},[_vm._v("\n  mdi-file-excel\n")])}
var staticRenderFns = []

export { render, staticRenderFns }